import services from 'services/services';
import * as types from '../types';
import { setRequestUrl } from 'store/actions';

// Import helpers
import {
	checkFetchErrors,
	queryParams
} from '../helpers_actions/convert_helpers';

// Import variables
import { TABLE_LENGTH } from 'components/helpers/table';

// ******************** FETCH SUBMENU - TABLE DATA ********************
export const fetchSubmenu = ({ options, parent_id }) => async (
	dispatch,
	getState
) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_SUBMENU_LOADING,
			payload: true
		});

		const {
			packets: {
				table: {
					columns,
					options: {
						filters: { filterUrlQuery },
						startIndex: startTableIndex,
						page
					}
				}
			}
		} = getState();

		const startIndex =
			options.page === page ? startTableIndex : options.startIndex;

		const url = `/menus/list?parent_id=${parent_id}&${filterUrlQuery}${queryParams(
			options,
			TABLE_LENGTH,
			columns,
			startIndex
		)}`;

		const { data } = await services.get(url);
		// Calculate pages
		const pages = Math.ceil(data.recordsFiltered / TABLE_LENGTH);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_SUBMENU_SUCCESS,
			payload: { ...data, pages, page: options.page, startIndex }
		});

		// save request url in redux
		setRequestUrl(url)(dispatch);
	} catch (error) {
		dispatch({
			type: types.FETCH_SUBMENU_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};

// ******************** DELETE SUBMENU ITEM ********************
export const deleteSubmenu = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.DELETE_SUBMENU_ITEM_LOADING,
			payload: true
		});

		await services.delete(`/menus/${id}`);
		// Dispatch an action with data
		dispatch({
			type: types.DELETE_SUBMENU_ITEM_SUCCESS,
			payload: true
		});
	} catch (error) {
		// Dispatch an action with error set to true
		dispatch({
			type: types.DELETE_SUBMENU_ITEM_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};

// ******************** SET SEARCH QUERY ********************
export const setSubmenuQuery = (query) => ({
	type: types.SET_SUBMENU_SEARCH_QUERY,
	payload: query
});
